import React, { useState, useEffect } from 'react';

/**
 * DL-7: Isolated "Searching…" label with animated dots. It owns its own 500ms
 * interval, so the 2Hz tick re-renders ONLY this leaf — not the whole
 * DirectoryPage (which would otherwise re-render the toolbar and the
 * non-memoised GoogleMapView twice a second while a search is in flight).
 * It is rendered only while loading, so the interval only runs then.
 */
const SearchingDots: React.FC = () => {
    const [dots, setDots] = useState('.');
    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => prev === '.' ? '..' : prev === '..' ? '...' : '.');
        }, 500);
        return () => clearInterval(interval);
    }, []);
    return (
        <span className="text-sm text-brand-primary whitespace-nowrap">
            Searching<span aria-hidden="true">{dots}</span>
        </span>
    );
};

export default React.memo(SearchingDots);
